<script setup lang="ts">
interface Props {
  hasHamburger: boolean
  hasDropdown: boolean
  hasBackButton: boolean
  isTablet?: boolean
}

const emits = defineEmits(['openSpotSelection'])
const route = useRoute()
const router = useRouter()
const appStore = useAppStore()
const authStore = useAuthStore()

const props = defineProps<Props>()

function openSpothopperSidebar() {
  window.parent.postMessage(
    'openSpothopperSidebar',
    import.meta.env.VITE_SH_URL,
  )
}

const handleBackButton = () => {
  appStore.isLoading = true
  if (!props.hasBackButton && props.isTablet) {
    const inquiryType = route.query.inquiry_type
    const urlPrefix = `${import.meta.env.VITE_SH_URL}/admin/spots/${appStore.spotInfo.id}/`
    const backUrlMap = {
      'Private Party': `${urlPrefix}private_parties_inquiries`,
      Catering: `${urlPrefix}catering_inquiries`,
      Reservation: `${urlPrefix}reservation_inquiries`,
      'Job Listings': `${urlPrefix}job_listings_inquiries`,
      'Delivery Order': `${urlPrefix}order_inquiries`,
      'Pick Up Order': `${urlPrefix}order_inquiries`,
      Other: `${urlPrefix}contact_form_inquiries`,
      'Other Custom': `${urlPrefix}contact_form_inquiries`,
    }
    if (window.top && window.top !== window.self) {
      let backUrl = backUrlMap[inquiryType as keyof typeof backUrlMap]
      if (backUrl === undefined) backUrl = `${urlPrefix}contact_form_inquiries`
      window.top.location.href = backUrl
    }
  } else {
    delete route.query.inquiry_id
    router.push({
      path: '/',
      query: route.query,
    })
  }
}

const handleOpenSettingsPage = () => {
  router.push(`/settings?spot_id=${authStore.spotId}`)
}

const hasMultipleSpots = computed(() => {
  if (appStore.spotsForUser) {
    return appStore.spotsForUser.length > 1
  }
})
</script>

<template>
  <div
    :class="hasHamburger ? 'px-3 py-2' : 'p-4'"
    class="flex cursor-pointer items-center bg-brand-dark"
  >
    <!-- back button -->
    <div
      v-if="props.hasBackButton || (!props.hasBackButton && props.isTablet)"
      class="absolute left-2 cursor-pointer rounded-full border border-[#405162] p-2.5"
      @click="handleBackButton"
    >
      <HeroiconsChevronLeft class="h-5 w-5 text-white" />
    </div>
    <!-- hamburger button -->
    <div
      v-if="props.hasHamburger && !props.isTablet"
      class="cursor-pointer rounded-full border border-[#405162] p-2"
      :class="{
        'absolute left-2': route.query.inquiry_id,
      }"
      @click="openSpothopperSidebar"
    >
      <HeroiconsBars3 class="h-8 w-8 text-white" />
    </div>
    <!-- content-->
    <slot />
    <!-- chevron button -->
    <div
      v-if="props.hasDropdown && hasMultipleSpots"
      class="cursor-pointer"
      @click="emits('openSpotSelection')"
    >
      <div class="flex gap-1 rounded-lg border border-[#405162] p-2">
        <AppiconCog class="h-5 w-5 fill-white" />
        <HeroiconsChevronDown class="h-5 w-5 text-white" />
      </div>
    </div>
    <div
      v-if="props.hasDropdown && !hasMultipleSpots"
      class="cursor-pointer rounded-lg border border-[#405162] p-2"
      @click="handleOpenSettingsPage"
    >
      <AppiconCog class="h-5 w-5 fill-white" />
    </div>
  </div>
</template>
